export const queryKeys = {
    subscription: () => ["subscription"],
    transaction: () => ["transaction"],
    pendingTransactions: () => ["transaction", "pending"],
};

export interface ActiveSubscription {
    productId: string;
    transactionId: string;
    name: string;
    description: string;
    price: string;
    startDate: string;
    endDate: string;
}

export type PaymentProvider = "stripe" | "google_iap" | "apple_iap";

enum TransactionState {
    pending = "pending",
    completed = "completed",
    failed = "failed",
}

export interface UserSubscription {
    id: string;
    active: boolean;
    user_id: string;
    status: string;
    starts_at: Date;
    ends_at: Date;
    canceled_at?: Date;
    canceled_reason?: string;
    auto_renew: boolean;
    trial_starts_at?: Date;
    trial_ends_at?: Date;
    product_id: string;
    description?: string;
    amount: string;
    currency: string;
    payment_plan: SubscriptionPlan;
    provider: string;
    stripe_subscription_id?: string;
}

export interface SubscriptionMetadata {
    discount_amount: number;
}
export interface SubscriptionPlan {
    id: string;
    name: string;
    description: string;
    amount: string;
    currency: string;
    interval: string;
    features: string[];
    trial_period_days?: number;
    stripe_product_id: string;
    stripe_price_id: string;
    apple_product_id: string;
    apple_subscription_group_id: string;
    google_product_id: string;
    google_base_plan_id: string;
    metadata: SubscriptionMetadata;
    status: string;
}

export interface InitiatePaymentResponse {
    success: boolean;
    transaction_id: string;
    transaction_status: string;
    user_uuid: string;
}

export interface Transaction {
    id: string;
    amount: string;
    currency: string;
    processed_at: string;
    provider_name: string;
    provider_uuid: Record<string, unknown>;
    status: TransactionState;
    transaction_type: string;
    user_id: string;
    user_uuid: Date;
    payment_plan: SubscriptionPlan;
    created_at: Date;
    cool_off_time: Date | null;
}
